// extracted by mini-css-extract-plugin
module.exports =  {"tabsWrapper":"tabsWrapper___ZpKt7","tabs":"tabs___Gj7MW","navTabs":"navTabs___oc0za"};